<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j7CsKK/tc-custom/9780374714857.jpg?1721656084594" alt="This image is the cover for the book Instructions for a Funeral"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Instructions for a Funeral
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Poetic, insightful, and deeply moving. David Means is one of my very favorite writers." —Tara Westover, author of <i>Educated</i><br/></b><br/>Following the publication of his widely acclaimed, Man Booker-nominated novel <i>Hystopia</i>, David Means here returns to his signature form: the short story. Thanks to his four previous story collections, Means has won himself an international reputation as one of the most innovative short fiction writers working today: an “established master of the form.” (Laura Miller, <i>The Guardian</i>). <i>Instructions for a Funeral</i>—featuring work from <i>The New Yorker</i>, <i>Harper’s</i>, <i>The Paris Review</i>, and <i>VICE</i>—finds Means branching out beyond the explorations of violence and trauma with which he is often identified, prominently displaying his sly humor and his inimitable way of telling tales that deliciously wind up to punch the reader in the heart. With each story Means pushes into new territory, writing with tenderness and compassion about fatherhood, marriage, a homeless brother, the nature of addiction, and the death of a friend at the hands of a serial-killer nurse. Means transmutes a fistfight in Sacramento into a tender, life-long love story; two FBI agents on a stakeout in the 1920s into a tale of predator and prey, paternal urges and loss; a man’s funeral instructions into a chronicle of organized crime, real estate ventures, and the destructive force of paranoia.<br/><br/>Means’s work has earned him comparisons to Flannery O’Connor, Alice Munro, Sherwood Anderson, Denis Johnson, Edgar Allan Poe, Anton Chekhov, and Raymond Carver but his place in the American literary landscape is fully and originally his own.<br/><br/><b>"David Means is a master of tense, distilled, quintessentially American prose. Like any artist who has finely honed his talent to its strongest expression he is a brilliant craftsman whose achievement is to appear unstudied, even casual . . . Each story by Means which I have read is unlike the others, unexpected and an unnerving delight." —Joyce Carol Oates</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Means
      </h2>
      
      <p class="authorDescription body article"><B>David Means </B>was born and raised in Michigan. His <I>Assorted Fire Events</I> earned the Los Angeles Times Book Prize for fiction and <I>The Secret Goldfish</I> was short-listed for the Frank O’Connor International Short Story Prize. <I>The Spot</I> was selected as a 2010 Notable Book by <I>The New York Times</I> and won the O. Henry Prize. His first novel, <I>Hystopia</I>, was published in 2016 to wide acclaim and was long-listed for the Man Booker Prize. Means’s fiction has appeared in <I>The New Yorker</I>, <I>Harper’s Magazine</I>, <I>Esquire</I>, <I>The Best American Short Stories</I>, <I>The O. Henry Prize Stories</I>, and numerous other publications. He lives in Nyack, New York, and teaches at Vassar College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad289e48